export default () => ({
  component: 'source-filter',
});
